import slotShouldForwardProp from './slotShouldForwardProp.esm.js';

const rootShouldForwardProp = prop => slotShouldForwardProp(prop) && prop !== 'classes';
var rootShouldForwardProp$1 = rootShouldForwardProp;

export { rootShouldForwardProp$1 as default };
